var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCharging(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8212 26.8925L12.6787 25.6075L15.2925 21.25H9.04248L13.9287 13.1075L16.0712 14.3925L13.4575 18.75H19.7075L14.8212 26.8925Z",
    fill: "#041018"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 8.75H36.25V5H33.75V8.75H32.5V16.25H33.75V30.625C33.75 31.1223 33.5525 31.5992 33.2008 31.9508C32.8492 32.3025 32.3723 32.5 31.875 32.5C31.3777 32.5 30.9008 32.3025 30.5492 31.9508C30.1975 31.5992 30 31.1223 30 30.625V20C30 19.6685 29.8683 19.3505 29.6339 19.1161C29.3995 18.8817 29.0815 18.75 28.75 18.75H23.75V6.25C23.75 5.91848 23.6183 5.60054 23.3839 5.36612C23.1495 5.1317 22.8315 5 22.5 5H6.25C5.91848 5 5.60054 5.1317 5.36612 5.36612C5.1317 5.60054 5 5.91848 5 6.25V32.5H2.5V35H26.25V32.5H23.75V21.25H27.5V30.625C27.5 31.7853 27.9609 32.8981 28.7814 33.7186C29.6019 34.5391 30.7147 35 31.875 35C33.0353 35 34.1481 34.5391 34.9686 33.7186C35.7891 32.8981 36.25 31.7853 36.25 30.625V16.25H37.5V8.75ZM21.25 32.5H7.5V7.5H21.25V32.5Z",
    fill: "#041018"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharging);
export default __webpack_public_path__ + "static/media/charging.9be06f8b.svg";
export { ForwardRef as ReactComponent };